import { registerImplementation } from '@ardoq/features';
import * as featureInterface from './featureInterface';

export const initializeFeatureInterface = () => {
  registerImplementation(featureInterface);
};
